import { FormTextboxQuestion, IFormTextboxQuestion } from '../../gamma/form/formquestion/formquestion-textbox';

export class U2000_AddressQuestion extends FormTextboxQuestion {
    static schema: IFormTextboxQuestion = {
        key: 'address',
        label: 'lblAddress',
        maxLength: 60,
    };

    constructor(options: IFormTextboxQuestion = {}) {
        super(options);
        const schema = U2000_AddressQuestion.schema;

        if (String.isNullOrEmpty(this.key)) {
            this.key = schema.key;
        }
        if (String.isNullOrEmpty(this.label)) {
            this.label = schema.label;
        }
        if (this.maxLength == null) {
            this.maxLength = schema.maxLength;
        }
    }
}
